import { Tooltip } from '@mui/material'
import { Error, Info } from '@mui/icons-material'
import React from 'react'
import Colors from 'utils/Colors'

import { DD_FIELDS } from 'utils/constants/bgcFields'
import { buildScore } from 'utils/functions'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import RemoveIcon from '@mui/icons-material/Remove'
import { reportErrorMessage } from 'utils/errorReporter'
import styles from '../styles'

const BuildDueDiligenceScoreBoard = (props) => {
  const classes = styles()
  const { scoreBoardData } = props

  const showWaitingClockIcon = () => (
    <AccessTimeIcon style={{ color: Colors.gray, fontSize: '2rem' }} />
  )

  const scoreTitle = (type) => {
    switch (type) {
      case DD_FIELDS.ATTORNEY_ACTIVITIES:
        return 'Atuação como procurador'
      case DD_FIELDS.EXTERNAL_ACTIVITIES:
        return 'Atividades externas'
      case DD_FIELDS.NEGATIVE_MEDIA:
        return 'Mídia negativa'
      case DD_FIELDS.PEP:
        return 'Pessoa exposta publicamente'
      case DD_FIELDS.PROFESSIONAL_ACTIVITIES:
        return 'Atividades profissionais'
      case DD_FIELDS.REPRESENTATION_ACTIVITIES:
        return 'Atividades de representação'
      case DD_FIELDS.RESTRICTION_DATA:
        return 'Listas Restritivas'
      case DD_FIELDS.SOCIAL_NETWORK:
        return 'Redes sociais de uso profissional'
      case DD_FIELDS.XP_KINSHIP:
        return 'Parentescos com funcionários da XP Inc.'
      case DD_FIELDS.PROCESSES:
        return 'Processos Judiciais'
      default:
        return null
    }
  }
  const showPointsCell = (field) => (
    <React.Fragment>
      {scoreBoardData.score_data[DD_FIELDS[field]].value}

      {scoreBoardData.score_data[DD_FIELDS[field]].value < 1 &&
        scoreBoardData.score_data[DD_FIELDS[field]].value !== 0
        ? ' ponto'
        : ' pontos'}
    </React.Fragment>
  )

  const showReasonCell = (field) =>
    scoreBoardData.score_data[DD_FIELDS[field]].reason ? (
      scoreBoardData.score_data[DD_FIELDS[field]].reason
    ) : (
      <Error style={{ color: Colors.yellow }} />
    )

  const renderError = () => {
    const errorMsg = 'Ocorreu um erro ao tratar os dados da Pontuação do Due Diligence'
    reportErrorMessage(errorMsg, 'BuildDDScoreBoard', scoreBoardData)

    return (
      <tbody>
        <tr className={classes.errorCaptured}>
          <td colSpan="20" style={{ padding: 10 }}>
            {errorMsg}
          </td>
        </tr>
      </tbody>
    )
  }  

  return (
    <div className={classes.container}>
      <table className={classes.dataTable}>
        <thead>
          <tr>
            <th>Parâmetro</th>
            <th>
              <span>
                <span>Pontuação</span>
                <span>
                  <Tooltip title="Quanto maior o score, maior o risco">
                    <Info fontSize="small" style={{ color: '#AAA' }} />
                  </Tooltip>
                </span>
              </span>
            </th>
            <th>Motivo</th>
          </tr>
        </thead>
        {scoreBoardData && (
          <tbody>
            {Object.keys(DD_FIELDS).map((field) => {
              const title = scoreTitle(DD_FIELDS[field])
              return (
                title && (
                  <tr key={`tr:${field}`}>
                    <td>{title}</td>
                    <td>
                      {scoreBoardData.score_data[DD_FIELDS[field]]
                        ? showPointsCell(field)
                        : showWaitingClockIcon()}
                    </td>
                    <td>
                      {scoreBoardData.score_data[DD_FIELDS[field]]
                        ? showReasonCell(field)
                        : showWaitingClockIcon()}
                    </td>
                  </tr>
                )
              )
            })}
            <tr style={{ fontWeight: 'bold' }}>
              <td>Score Final</td>
              <td>
                {scoreBoardData?.score_sum != null ? (
                  <span style={buildScore(scoreBoardData.final_score)}>
                    {`
                  ${scoreBoardData.score_sum} 
                  ${scoreBoardData.score_sum < 1 &&
                        scoreBoardData.score_sum !== 0
                        ? ' ponto'
                        : ' pontos'
                      }
                `}
                  </span>
                ) : (
                  showWaitingClockIcon()
                )}
              </td>
              <td>
                <RemoveIcon style={{ fontWeight: 'bold' }} />
              </td>
            </tr>
          </tbody>
        )}
        {!scoreBoardData && renderError()}
      </table>
    </div>
  )
}

export default BuildDueDiligenceScoreBoard
